module.exports = __webpack_public_path__ + "static/jamiejones_0-d7551d71e306b2b2e98a1993c70ca5ea.jpg";